module.exports = __webpack_public_path__ + "static/media/user-lookup.e4a13ad8.png";